import { Message } from "primereact/message";
import * as React from "react";

interface AuthSuccessMessageProps {
  title: string;
  message: string;
  helpText?: string;
}

export const AuthSuccessMessage: React.FC<AuthSuccessMessageProps> = ({
  title,
  message,
  helpText,
}) => {
  return (
    <Message
      className="w-full justify-content-start bg-transparent text-green-200"
      style={{ border: "none", fontFamily: "var(--ghostnews-font-family)" }}
      content={
        <div className="flex align-items-start gap-3">
          <i className="pi pi-envelope text-xl mt-1" />
          <div className="flex flex-column gap-2">
            <p className="font-bold text-lg m-0">{title}</p>
            <p className="text-900 m-0">{message}</p>
            <p className="text-sm m-0 opacity-80">{helpText}</p>
          </div>
        </div>
      }
    />
  );
};

export default AuthSuccessMessage;
